import { parseSearchWith, stringifySearchWith } from "@tanstack/react-router";

/**
 * TanStack JSON-encodes search values so they can round-trip their types, which
 * turns ?page=2 into ?page=%222%22 once written back. This app treats every
 * query value as a plain string and coerces types itself (see
 * useUrlFilterState), so keep the plain-string behaviour and leave URLs
 * readable. Both the app router and the test router use these.
 */
export const parseSearch = parseSearchWith((value) => value);
export const stringifySearch = stringifySearchWith((value) => String(value));
